/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function() {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    );

  if ('serviceWorker' in navigator &&
      (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
    .then(function(registration) {
      // updatefound is fired if service-worker.js changes.
      registration.onupdatefound = function() {
        // updatefound is also fired the very first time the SW is installed,
        // and there's no need to prompt for a reload at that point.
        // So check here to see if the page is already controlled,
        // i.e. whether there's an existing service worker.
        if (navigator.serviceWorker.controller) {
          // The updatefound event implies that registration.installing is set:
          // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
          var installingWorker = registration.installing;

          installingWorker.onstatechange = function() {
            switch (installingWorker.state) {
              case 'installed':
                // At this point, the old content will have been purged and the
                // fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in the page's interface.
                break;

              case 'redundant':
                throw new Error('The installing ' +
                                'service worker became redundant.');

              default:
                // Ignore
            }
          };
        }
      };
    }).catch(function(e) {
      console.error('Error during service worker registration:', e);
    });
  }

  // Your custom JavaScript goes here

  let doc = document
  let win = window

  doc.addEventListener('DOMContentLoaded', ()=>{

    function adjustScale() {
      const container = document.getElementById('container');
      const screenWidth = window.innerWidth;
      const containerWidth = 360; // Ancho original del contenedor sin escalar
      const scaleValue = screenWidth / containerWidth;

      if (screenWidth < containerWidth) {
        // Ajustar transform origin para que la escala ocurra desde la esquina superior izquierda
        container.style.transformOrigin = 'top left';

        doc.body.style.width = `scale(${scaleValue})`
        doc.documentElement.style.width = `scale(${scaleValue})`

        // Aplicar la transformación de escala al contenedor
        container.style.transform = `scale(${scaleValue})`;

        // Calcular la altura del contenedor escalado
        const containerHeight = container.clientHeight * scaleValue;

        // Establecer el alto mínimo del HTML según la altura del contenedor escalado
        document.documentElement.style.maxHeight = `${containerHeight}px`;

        // Ocultar el desplazamiento horizontal y permitir el desplazamiento vertical
        document.documentElement.style.overflowX = 'hidden';
        document.documentElement.style.overflowY = 'auto';
      } else {
        doc.body.style.width = `auto`
        doc.documentElement.style.width = `auto`
        // Restablecer al tamaño original si la pantalla es lo suficientemente grande
        container.style.transform = 'scale(1)';
        document.documentElement.style.minHeight = '100%'; // Ajustar al alto completo de la pantalla
        document.documentElement.style.overflow = 'auto'; // Restablecer el desplazamiento
      }
    }

// Llamar a la función inicialmente cuando se carga la página
    adjustScale();

// Agregar un listener de evento para ajustar la escala en cada redimensionamiento de la ventana
    window.addEventListener('resize', adjustScale);
    window.addEventListener('load', adjustScale);


    const currentUrl = win.location.href;
    const parts = currentUrl.split('/');
    const afterFirstSlash = parts.slice(3).join('/');

    win.addEventListener('beforeunload', ()=>{
      localStorage.clear();
    })

    win.addEventListener('unload', ()=>{
      localStorage.clear();
    })

    let backToTopBtn = doc.getElementById("backToTopBtn")
    let inactivityTimer;

    function toggleBackToTopBtn(){
      if (doc.body.scrollTop > 20 || doc.documentElement.scrollTop > 20){
        backToTopBtn.classList.remove("hidden")
        backToTopBtn.classList.add("block");
        resetInactivityTimer();
      }else{
        backToTopBtn.classList.remove("block")
        backToTopBtn.classList.add("hidden")
      }
    }

    function resetInactivityTimer(){
      clearTimeout(inactivityTimer);
      backToTopBtn.classList.add("opacity-100");
      inactivityTimer = setTimeout( () => {
        backToTopBtn.classList.remove("opacity-100")
        backToTopBtn.classList.add("opacity-0")
      }, 2000)
    }

    win.addEventListener('scroll', toggleBackToTopBtn);
    ['scroll', 'keydown'].forEach( event => {
      win.addEventListener(event, resetInactivityTimer);
    });

    backToTopBtn.addEventListener('click', function() {
      win.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })

    const arrowContainer = doc.getElementById('arrowContainer');
    const arrowSvg = arrowContainer.innerHTML;

    let rec = doc.getElementById("rec_main")

    async function updateBtnToUpContent() {
      if (win.innerWidth < 992) { // md breakpoint is 960px
        backToTopBtn.innerHTML = arrowSvg;

      }else{
        backToTopBtn.innerHTML = "Volver arriba";

      }
    }

    updateBtnToUpContent();
    win.addEventListener('resize', updateBtnToUpContent);

    if (afterFirstSlash == "" ||
        afterFirstSlash == "index.html" ||
        afterFirstSlash == "index.html#productos" ||
        afterFirstSlash == "index.html#servicios" ||
        afterFirstSlash == "index.html#nosotros" ||
        afterFirstSlash == "index.html#socios" ||
        afterFirstSlash == "index.html#contacto"
    ){
      const container = document.getElementById('gridContainer');
      const items = container.querySelectorAll('.grid-item');
      let currentIndex = 0;
      let intervalId = null;

      if (container && items.length > 0) {
        // Función para avanzar al siguiente slide automáticamente cada 4 segundos
        function avanzarAutomaticamente() {
          intervalId = setInterval(() => {
            currentIndex = (currentIndex + 1) % items.length;
            const selectedItem = items[currentIndex];
            container.scrollTo({
              left: selectedItem.offsetLeft,
              behavior: 'smooth'
            });
          }, 4000); // 4000 milisegundos = 4 segundos
        }

        // Iniciar el avance automático
        avanzarAutomaticamente();

        // Detener el avance automático si el usuario interactúa con el carrusel
        container.addEventListener('scroll', () => {
          clearInterval(intervalId);
          avanzarAutomaticamente();
        });

        // Función para manejar el scroll y ajustar currentIndex
        function handleScroll() {
          const scrollLeft = container.scrollLeft;

          let closestIndex = 0;
          let closestDistance = Infinity;

          items.forEach((item, index) => {
            const itemOffset = item.offsetLeft;
            const distance = Math.abs(itemOffset - scrollLeft);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          currentIndex = closestIndex; // Actualizar currentIndex al índice más cercano
        }

        // Llamar a handleScroll cuando se hace scroll en el contenedor
        container.addEventListener('scroll', debounce(handleScroll, 100));

        // Función debounce para mejorar el rendimiento
        function debounce(func, wait) {
          let timeout;
          return function () {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
          };
        }
      }

      win.addEventListener('resize', () => {
        if (win.innerWidth < 992){
          rec.classList.remove("back-form")
          rec.classList.add("back-form-2")
        }else{
          rec.classList.remove("back-form-2")
          rec.classList.add("back-form")
        }
      })
    }




    const menuButton = doc.getElementById('menu_toggle');
    const menu = doc.getElementById('menu')
    const opciones = doc.getElementsByName('opcion')
    const scroll = doc.getElementById('view-more')

    if (scroll){
      scroll.addEventListener('click', function(event) {
        event.preventDefault();
        let target = document.getElementById("productos");
        if (target) {
          let offset = target.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }
      });
    }

    let tel = doc.getElementById("tel")
    if (tel){
      tel.addEventListener('input', function (e) {
        e.target.value = e.target.value.replace(/[^\d]/g, '');
        if (e.target.value.length > 10) {
          e.target.value = e.target.value.slice(0, 10);
        }
      })
    }


    menuButton.addEventListener('click', ()=>{
      if (menu.classList.contains('hidden')){
        menu.classList.remove('hidden')
        menu.classList.add('flex')
      }else{
        menu.classList.remove('flex')
        menu.classList.add('hidden')
      }
    })

    window.addEventListener('click', (event) => {
      if (!menu.contains(event.target) && !menuButton.contains(event.target)) {
        menu.classList.remove('flex');
        menu.classList.add('hidden');
      }
    });

    opciones.forEach(option => {
      option.addEventListener('click', () => {
        menu.classList.remove('flex');
        menu.classList.add('hidden');
      })
    })
  })


  $(document).ready(function() {
    $('#contactForm').on('submit', function (e) {
      e.preventDefault();
      $('#loadingModal').addClass('show');
      $.ajax({
        type: 'POST',
        url: '/assets/php/contact.php',
        data: $(this).serialize(),
        success: function(response) {
          // Ocultar modal de carga
          $('#loadingModal').addClass('hide');
          $('#loadingModal').removeClass('show');

          // Mostrar modal de respuesta
          $('#responseMessage').html(response);
          $('#responseModal').removeClass('hide');
          $('#responseModal').addClass('show');
        },
        error: function(xhr, status, error) {
          // Ocultar modal de carga

          $('#loadingModal').removeClass('show');
          $('#loadingModal').addClass('hide');

          // Mostrar modal de respuesta con mensaje de error
          $('#responseMessage').html('Error al enviar el mensaje. Por favor, intenta nuevamente.');
          $('#responseModal').removeClass('hide');
          $('#responseModal').addClass('show');
        }
      })
    })
  })

})();


